import AdapterJalali from '@date-io/date-fns-jalali';
import {DatePicker} from '@mui/x-date-pickers/DatePicker';
import {LocalizationProvider} from '@mui/x-date-pickers/LocalizationProvider';
import React from "react";
import {FormControl, InputGroup} from "react-bootstrap";
import {CalendarIcon} from "../assets";

export default function JalaliDatePicker(props) {

    return (
        <LocalizationProvider dateAdapter={AdapterJalali}>
            <DatePicker
                mask="____/__/__"
                value={props.value}
                label={" تاریخ تولد"}
                openTo="year"
                closeOnSelect={true}
                disabled={props.disabled}
inputFormat="yyyy/MM/dd"
                views={['year', 'month', 'day']}
                onChange={props.onChange} renderInput={({inputRef, inputProps, InputProps}) => (
                <InputGroup>
                    <div className="icon">
                        <CalendarIcon/>
                    </div>
                    <FormControl {...inputProps} type="text"
                                 size="lg"/>
                    {InputProps?.endAdornment}
                </InputGroup>
            )}
            />
        </LocalizationProvider>
    );
}
